import Message from './main.js'
export default Message
